import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/modules/shared/services/google-tag-manager.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { isPlatformServer } from '@angular/common';
import { RelatedProduct, SharedProduct } from './product.entities';

@Component({
  selector: 'product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnInit {
  @Input() rowType: number;
  @Input() product;
  @Input() homeIndexData?: {
    moduleIndex: number;
    productIndex: number;
  };
  @Input() expandMode: boolean = false;
  @Input() isBlackFriday: boolean = false;

  productCard;
  storeDetail;
  isServerSide: boolean = false;
  platformId: Object;

  constructor(
    private storeDetailResolver: StoreDetailService,
    private googleTagManagerService: GoogleTagManagerService,
    @Inject(PLATFORM_ID) platFormId: Object
  ) {
    this.platformId = platFormId;
    this.isServerSide = isPlatformServer(this.platformId);
  }

  ngOnInit(): void {
    this.getStoreDetail();
    this.createProductModel();
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
  }

  createProductModel() {
    if (this.rowType == 1 || this.rowType == 3 || this.rowType == 4) {
      this.productCard = new SharedProduct(this.product, this.storeDetail);
    }
    if (this.rowType == 10) {
      this.productCard = new RelatedProduct(this.product, this.storeDetail);
    }
  }

  onCategoryLink() {
    let analyticData = {
      name: this.product.title,
      id: this.product?.extra_info?.id,
    };

    this.googleTagManagerService.sendAnalytics('view_category', {
      ...analyticData,
    });
  }
}
